const INTERVIEWS_COUNT_THRESHOLD = {
  V75: 60,
  V86: 60,
  GS75: 40,
};

/**
 * Determines whether the interviews count should be displayed for the given round.
 *
 * If the round's betting type does not exist in the threshold map, the count is displayed when greater than 0.
 * If a threshold exists for the betting type, the count is displayed only if it meets or exceeds that threshold.
 *
 * @param {Object} round - The round object containing betting type and interviews count.
 * @returns {boolean} True if the interviews count should be visible, false otherwise.
 */
export const shouldShowInterviewsCount = round => {
  const betType = round.bet_type;

  if (!INTERVIEWS_COUNT_THRESHOLD[betType]) {
    return round.interview_count > 0;
  }

  return round.interview_count >= INTERVIEWS_COUNT_THRESHOLD[betType];
};
